/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createHook } from '../../core/factories/createHook.js';

import { createPrefetchHook } from '../../core/factories/createPrefetchHook.js';
import type { GetAdminCompetitionRow } from '../openapi-types.gen.js';
import { type useGetAdminCompetitionArgs, useGetAdminCompetitionSpec } from '../specs/admin.spec.gen.js';

export type { GetAdminCompetitionRow } from '../openapi-types.gen.js';
export type { useGetAdminCompetitionArgs } from '../specs/admin.spec.gen.js';


/**
 * Available query params (forwarded automatically; pass via the
 * hook's args): competitionId.
 */
const _useGetAdminCompetition = createHook(useGetAdminCompetitionSpec);
export const useGetAdminCompetition = _useGetAdminCompetition as (args: useGetAdminCompetitionArgs, opts?: import('../../core/factories/createHook.js').CreateHookCallOpts) => ReturnType<typeof _useGetAdminCompetition>;


/**
 * Hover/intent prefetch companion for `useGetAdminCompetition`. Returns a stable
 * `(args) => Promise<void>` callback that fires the real HTTP request
 * and writes the response into the SAME cache entry the reader hook
 * observes. The component owning the callback does NOT subscribe — no
 * re-renders on data, no NATS subscription. Idempotent: TanStack
 * `prefetchQuery` is a no-op when a fresh cache entry already exists.
 *
 *     function Link({ pubkey }) {
 *       const prefetch = usePrefetchGetAdminCompetition();
 *       return (
 *         <a
 *           onMouseEnter={() => prefetch({ pubkey })}
 *           onFocus={() => prefetch({ pubkey })}
 *         >…</a>
 *       );
 *     }
 */
export const usePrefetchGetAdminCompetition = createPrefetchHook(useGetAdminCompetitionSpec) as () => import('../../types/SdkPrefetchTask.js').SdkPrefetcher<useGetAdminCompetitionArgs>;
